<template>
  <footer class="OrderFormFooter" id="orderForm">
    <div class="footer">
      <div class="footer__left">
        <div
          v-if="canClickGoBack"
          @click="$emit('onClickGoBack')"
          class="BackButton"
        >
          <font-awesome-icon :icon="['fal', 'chevron-left']" size="2x" />
          <div class="BackButtonDescription">戻る</div>
        </div>
      </div>
      <div class="footer__center">
        <transition name="slide-left" mode="out-in">
          <div v-if="message">
            <p class="Message">{{ message }}</p>
          </div>
        </transition>
      </div>

      <div class="footer__right">
        <transition name="slide-left" mode="out-in">
          <div
            v-if="canClickGoForward"
            @click="$emit('onClickGoForward')"
            class="NextButton"
          >
            <div class="NextButtonDescription">進む</div>
            <font-awesome-icon :icon="['fal', 'chevron-right']" size="2x" />
          </div>
        </transition>
      </div>
    </div>

    <div class="OrderEditHistoryButton" v-if="isEditMode">
      <div class="content">
        <el-button @click="_onClickOpenEditHistory()">編集メモ</el-button>
      </div>
    </div>

    <div id="editDialog">
      <el-dialog :visible.sync="isShownDialog" :modal="false">
        <OrderNote class="chatBaloon" style="overflow-y:auto;height:350px;" />
      </el-dialog>
    </div>
  </footer>
</template>

<script>
import OrderNote from "@/views/OrderNote.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    canClickGoBack: {
      type: Boolean,
      default: false,
    },
    onClickGoBack: {
      type: Function,
      default: null,
    },
    canClickGoForward: {
      type: Boolean,
      default: false,
    },
    onClickGoForward: {
      type: Function,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
  },
  components: { OrderNote },
  data () {
    return {
      isShownDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      isEditMode: "orderForm/isEditMode",
    }),
  },
  mounted () {},
  methods: {
    _onClickOpenEditHistory () {
      this.isShownDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.footer {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  background-color: $background-blue-light;
}

.footer__left,
.footer__right,
.footer__center {
  display: flex;
  flex: 1;
  align-items: center;
}
.footer__center {
  flex: 3;
  justify-content: center;
}

.footer__right {
  justify-content: flex-end;
}

.BackButton {
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.8);
  margin-left: 10px;
}
.BackButtonDescription {
  font-size: 20px;
  margin-left: 10px;
}
.NextButton {
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.8);
  margin-right: 10px;
}
.NextButtonDescription {
  font-size: 20px;
  margin-right: 10px;
}
.Message {
  font-size: 1.2em;
  font-weight: bold;
}

.OrderEditHistoryButton {
  position: fixed;
  right: 100px;
  bottom: 30px;
  margin-right: 50px;
}

.OrderFormFooter {
  padding-top: 5rem !important;
}
</style>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

#orderFormFooter {
  background-repeat: repeat-x;
  margin-right: -11rem;
}
@media (max-width: 1024px) {
  #orderFormFooter {
    margin-right: -5rem;
  }
}
#orderFormFooter .content {
  width: 100%;
  margin-top: 0px;
  margin-right: 0px;
  position: relative;
}

#orderFormFooter .content .el-button {
  width: 100px;
  color: $blue-extra-deep;
  background-color: white;
  border: none;
}
@media (max-width: 1024px) {
  #orderFormFooter .content .el-button {
    right: 4rem;
  }
}
#orderFormFooter .dialog {
  background-color: red;
  padding: 0px 132px 0px 0px;
}
#editDialog {
  margin-right: 10rem;
}
#editDialog .el-dialog {
  border: 1px solid $--border-color-lighter !important;
  box-shadow: 1px 2px 9px 2px $--border-color-lighter;
  margin-right: 6.8rem !important;
  margin-bottom: 5rem !important;
}
@media (max-width: 1024px) {
  #editDialog .el-dialog {
    margin-right: 4.3rem !important;
  }
}
#editDialog .el-dialog__header {
  background: $--border-color-lighter !important;
}
#editDialog .el-dialog__headerbtn {
  top: 8px !important;
}
#editDialog .el-dialog__headerbtn .el-dialog__close {
  color: black !important;
}
#editDialog .v-modal {
  opacity: 1 !important;
  height: auto !important;
  background: unset !important;
}
#editDialog .el-dialog__wrapper {
  top: auto !important;
}
#editDialog .el-textarea__inner {
  height: auto !important;
}
#orderForm .chatBaloon .el-dialog__wrapper {
  padding-left: 11.9rem !important;
  position: fixed !important;
}
#orderForm .chatBaloon .el-dialog {
  width: 25% !important;
  border: none !important;
  margin-left: 37rem !important;
  margin-bottom: 12rem !important;
  box-shadow: none !important;
}
@media (max-width: 1024px) {
  #orderForm .chatBaloon .el-dialog {
    width: 25% !important;
    border: none !important;
    margin-left: 17rem !important;
    margin-bottom: 21rem !important;
    box-shadow: none !important;
  }
}
@media (max-width: 1024px) {
  #orderForm .chatBaloon .el-dialog {
    top: 6rem !important;
  }
}
#orderForm .chatBaloon .el-dialog__headerbtn {
  right: 0 !important;
}
#orderForm .chatBaloon .el-dialog__header {
  background: none !important;
}
#orderForm .dialog-image {
  margin: 0 !important;
  width: 100% !important;
}
</style>
